import styles from "./ImageLayoutTrio.module.css";
import ImageSlot from "./ImageSlot";

interface Props {
    editing?: boolean;
    images: { [key: string | number]: File | string | null };
    onImageChange?: (key: string | number, newImage: File | null) => void;
}

export default function ImageLayoutTrio({
    editing,
    images,
    onImageChange,
}: Props) {
    return (
        <div className={styles.imageContainer}>
            <ImageSlot
                label="Cover Image"
                image={images.cover}
                width={340}
                height={570}
                onImageChange={(img) => {
                    if (onImageChange) onImageChange("cover", img);
                }}
                editing={editing}
            />
            <div>
                <div className={styles.topRow}>
                    <ImageSlot
                        image={images[0]}
                        width={340}
                        height={280}
                        onImageChange={(img) => {
                            if (onImageChange) onImageChange(0, img);
                        }}
                        editing={editing}
                    />
                    <ImageSlot
                        image={images[1]}
                        width={340}
                        height={280}
                        onImageChange={(img) => {
                            if (onImageChange) onImageChange(1, img);
                        }}
                        editing={editing}
                    />
                </div>
                <ImageSlot
                    image={images[2]}
                    width={690}
                    height={280}
                    onImageChange={(img) => {
                        if (onImageChange) onImageChange(2, img);
                    }}
                    editing={editing}
                />
            </div>
            <ImageSlot
                label="Hover Image"
                image={images.hover}
                width={340}
                height={570}
                onImageChange={(img) => {
                    if (onImageChange) onImageChange("hover", img);
                }}
                editing={editing}
            />
        </div>
    );
}
